module.exports = __webpack_public_path__ + "static/media/02B.7f8720b7.png";